var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClaimCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 59,
    viewBox: "0 0 75 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1818_12510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 59
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 59,
    rx: 6,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1818_12510)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 53.1001,
    rx: 52,
    ry: 51.1333,
    fill: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0631 3.63579C56.6707 3.25505 56.0453 3.26005 55.659 3.64702L35.5642 23.7787C35.1801 24.1636 34.5588 24.1709 34.1656 23.7953L26.1304 16.1168C25.7351 15.7391 25.1097 15.7489 24.7264 16.1388L16.711 24.2923C16.32 24.6901 16.33 25.3309 16.7333 25.7163L34.3908 42.5899C34.7839 42.9656 35.4052 42.9583 35.7894 42.5734L65.2835 13.025C65.6775 12.6302 65.6724 11.9893 65.2721 11.6008L57.0631 3.63579Z",
    fill: "#DFE2F0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClaimCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/claim_check.0569885c3feee80c1e07977e38c7f44c.svg";